import { useState } from "react";

import { DefaultButton, Heading, Stack, Text, useTheme } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { useDeploymentDetail } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { DeploymentDetailTimeline } from "./DeploymentDetailTimeline";

interface DeploymentDetailTimelineHostProps {
  fieldDeviceId: string;
}

export const DeploymentDetailTimelineHost: React.FC<DeploymentDetailTimelineHostProps> = ({
  fieldDeviceId
}) => {
  const theme = useTheme();

  const [renderKey, setRenderKey] = useState(0);

  const deploymentDetailQuery = useDeploymentDetail(fieldDeviceId);

  const [fitZoom, setFitZoom] = useState(false);

  const handleResetTimeline = () => {
    setFitZoom(false);
    setRenderKey(renderKey + 1);
  };

  const handleFitZoom = () => {
    setFitZoom(true);
    setRenderKey(renderKey + 1);
  };

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign="center"
        tokens={{ childrenGap: theme.spacing.m }}
      >
        <Heading variant="section-heading">Rollouts Timeline</Heading>

        <Stack.Item align="center">
          <Text variant="small">
            Click and drag to pan timeline. Click header rows or Ctrl+Mouse
            wheel to zoom in or out. Click a rollout to navigate to the rollout
            edit page.
          </Text>
        </Stack.Item>
        <Stack.Item align="end">
          <Stack horizontal tokens={{ childrenGap: theme.spacing.s2 }}>
            <DefaultButton onClick={handleFitZoom}>Fit Zoom</DefaultButton>
            <DefaultButton onClick={handleResetTimeline}>
              Reset Zoom
            </DefaultButton>
          </Stack>
        </Stack.Item>
      </Stack>
      <QueryStateIndicator {...deploymentDetailQuery}>
        {detail => (
          <DeploymentDetailTimeline
            detail={detail}
            key={renderKey}
            fitZoom={fitZoom}
          />
        )}
      </QueryStateIndicator>
    </Stack>
  );
};
